export default class Dictionary {

  constructor() {
    return {
      custom: {
        ano: {
          required: () => "O Campo Ano não deve ser vazio",
          date_format: () => "Digite um ano válido Ex: 2019"
        },
        fazenda: {
          required: () => "O Campo Fazenda não deve ser vazio"
        },
        municipio: {
          required: () => "O Campo Municipio não deve ser vazio"
        },
        touroPesoMedio: {
          required: () => "O Campo Peso Médio kg/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        touroCabecaInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        touroCabecaFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        touroValor: {
          required: () => "O Campo Valor R$/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        vacaMatrizPesoMedio: {
          required: () => "O Campo Peso Médio kg/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        vacaMatrizCabecaInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        vacaMatrizCabecaFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        vacaMatrizValor: {
          required: () => "O Campo Valor R$/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },

        machos36PesoInicial: {
          required: () => "O Campo Peso(kg)Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36PesoFinal: {
          required: () => "O Campo Peso(kg)Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36Valor: {
          required: () => "O Campo Valor R$/Kg Vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36CabecasInicial: {
          required: () => "O Campo Cabeças-Inicial não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36CabecasFinal: {
          required: () => "O Campo Cabeças-Final não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        rebanhoMedioAnualEstimadoCabeca: {
          required: () => "O Campo Cabeças não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        rebanhoMedioAnualEstimadoUA: {
          required: () => "O Campo UA não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36PesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        touroPesoMedioKGVivo1: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },

        femeas36cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },

        femeas2436cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36cabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        tourocabeca1: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas012ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos012ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36ValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        touroValorUnitarioRSCabeca: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36PesoMedioKGVivo: {
          required: () => "O Campo Peso Medio kg vivo não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36cabeca: {
          required: () => "O Campo Peso Medio cab. não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36PesoMedioCarcaca: {
          required: () => "O Campo Peso Medio Carcaça não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas36ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas2436ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        femeas1224ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos1224ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos2436ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        machos36ValorUnitarioRS: {
          required: () => "O Campo Valor (R$/cab) não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        retiradaDoProdutorMes: {
          required: () => "O Campo R$/Mês não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        retiradaDoProdutorDedicacaoBovinocultura: {
          required: () => "O Campo Dedicação à Bovinocultura % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        retiradaFamiliaMes: {
          required: () => "O Campo R$/Mês não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        retiradaFamiliaDedicacaoBovinocultura: {
          required: () => "O Campo Dedicação à Bovinocultura % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        vendaProdutosBovinoculturaCorteValorTotal: {
          required: () => "O Campo R$ não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        receitaAluguelPastoValorTotal: {
          required: () => "O Campo R$ não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        precoArrobaBoiGordo: {
          required: () => "O Campo R$/@ não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        incluirJurosSobreDesoesasNaCompraAnimaisRecriaEngorda: {
          required: () => "Uma opção deve ser escolhida",
          max: () => "O Campo deve ser preenchido com uma das opções"
        },
        incluirJurosSobreDemaisDespesas: {
          required: () => "Uma opção deve ser escolhida",
          max: () => "O Campo deve ser preenchido com uma das opções"
        },
        taxaJurosDespesasCompraAnimaisRecriaEngorda: {
          required: () => "O campo Taxa de Juros não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        taxaJurosDemaisDespesas: {
          required: () => "O campo Taxa de Juros não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Início Dicionário Dados Despesas Manutenção
        manutencaoFertilizante: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoArrendamento: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCercaConvencional: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCurral: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoGalpao: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCasaSede: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCasaEmpregados: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoAcudes: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCaixaDAgua: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRedeHidraulica: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoBebedouros: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRedeEletrica: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCochoCoberto: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCochoSalRustico: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCochoSuplementacao: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoTratorMedio: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCarretaAgricola: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRocadeira: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCamioneta: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoGradeIntermediaria: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoSemeadeira: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoArreios: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoFerramentas: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoEquipInformatica: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoTelefone: {
          required: () => "O Campo Valor R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Fim Dicionário Dados Despesas Manutenção

        //Início Dicionário Dados Despesas Animal
        manutencaoCabecaFemeas36: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaFemeas2436: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaFemeas1224: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaFemeas012: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaMachos012: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaMachos1224: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaMachos2436: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoCabecaMachos36tourunos: {
          required: () => "O Campo Cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoFemeas36: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoFemeas2436: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoFemeas1224: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoFemeas012: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoMachos012: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoMachos1224: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoMachos2436: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoKGVivoMachos36tourunos: {
          required: () => "O Campo Kg vivo/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabFemea36: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabFemea2436: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabFemea1224: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabFemea012: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabMachos012: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabMachos1224: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabMachos2436: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRSCabMachos36tourunos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoSalMineral: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoSalProteinado: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoRacao: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoOutros: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoVacinas: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoVermifugos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoMedicamentos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoOutrosprodutosVeterinarios: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoInsumos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        manutencaoMaoDeObra: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Fim Dicionário Dados Despesas Animal

        //Início Dicionário Dados Despesas Serviços
        ServicoTotal: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoTotalBovinoculturaCorte: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoSalarioEncargosTotal: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoSalarioEncargosPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoGratificacoesTotal: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoGratificacoesPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoMaoDeObraTemporariaTotal: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoMaoDeObraTemporariaPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoServicosTecnicos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoTaxaImpostos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoItrPago: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoProporcaoAreaFazenda: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoAnuidadesSindicatos: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoAnuidadesSindicatosPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoComissoesComprasVendas: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoEscritorioContabilidade: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoEscritorioContabilidadePorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoMaterialIdentificacaoGado: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoFretesBovinocultura: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoEnergiaEletrica: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoEnergiaEletricaPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoTelefone: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoTelefonePorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoSeguros: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoSegurosPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoDespesasDiversas: {
          required: () => "O Campo R$/ano não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ServicoDespesasDiversasPorcentagem: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Fim Dicionário Dados Despesas Serviços

        //Início Dicionário Dados Recursos Pastagens
        QuantidadeTotalCapineiras: {
          required: () => "O Campo ha não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        BovinoCulturaCapineiras: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ValorInicialCapineiras: {
          required: () => "O Campo R$/ha não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ValorResidualCapineiras: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        VidaUtilCapineiras: {
          required: () => "O Campo anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        HaSilagem: {
          required: () => "O Campo ha não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MesesSilagem: {
          required: () => "O Campo meses não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        QuantidadeTotalOutras: {
          required: () => "O Campo ha não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        BovinoCulturaOutras: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ValorInicialOutras: {
          required: () => "O Campo R$/ha não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        ValorResidualOutras: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        VidaUtilOutras: {
          required: () => "O Campo Anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TaxaJurosPastagens: {
          required: () => "O Campo % anual não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Fim Dicionário Dados Recursos Pastagens

        //Início Dicionário Dados Recursos Animais
        TourosValorResidual: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TourosVidaUtil: {
          required: () => "O Campo Anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TourosAno: {
          required: () => "O Campo cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TaxaJurosTouros: {
          required: () => "O Campo % anual não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        VacasValorResidual: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        VacasVidaUtil: {
          required: () => "O Campo Anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        VacasAno: {
          required: () => "O Campo cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TaxaJurosMatrizes: {
          required: () => "O Campo % anual não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        EquinosCab: {
          required: () => "O Campo cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        EquinosValorInicial: {
          required: () => "O Campo R$/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        EquinosValorResidual: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        EquinosVidaUtil: {
          required: () => "O Campo Anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        EquinosBovinoCultura: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MuaresCab: {
          required: () => "O Campo cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MuaresValorInicial: {
          required: () => "O Campo R$/cab não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MuaresValorResidual: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MuaresVidaUtil: {
          required: () => "O Campo Anos não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        MuaresBovinoCultura: {
          required: () => "O Campo % não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        TaxaJuroAnimais: {
          required: () => "O Campo % anual não deve ser vazio",
          max: () => "O Campo não deve ter mais que 8 números"
        },
        //Fim Dicionário Dados Recursos Animais
      }
    }
  }
}